import MenuCatalog from "../components/MenuCatalog";

export default function MenuPage() {
  return (
    <MenuCatalog
      seoTitle="Menu"
      seoDescription="Browse The Canopy menu featuring pit beef sandwiches, smoky BBQ, delicious sides, and more."
      seoPath="/menu"
      seoImage="/images/pitbeefsandwich.avif"
      pageTitle="Our Menu"
      pageSubtitle="Bold flavors, made fresh to order."
      dataUrl="/menu.json"
      actionsIntro="Have an event, check out our catering menu"
      actions={[
        {
          label: "View Catering Menu",
          to: "/menu/catering",
          variant: "primary",
        },
        {
          label: "Catering Details",
          to: "/catering",
          variant: "secondary",
        },
      ]}
    />
  );
}
